import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ValidationErrorMessage from './ValidationErrorMessage';
import map from 'lodash/map'

export default class ValidatedInput extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    className: PropTypes.string,
    isRequired: PropTypes.bool,
    validator: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array
  }

  static defaultProps = {
    defaultClassNames: "form-input has-floating-label",
    isRequired: false,
    inputType: "text",
    validator: () => {}
  }

  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      errorMessage: props.validator(props.value)
    };
  }

  handleChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const errorMessage = this.props.validator(value);
    this.setState({ errorMessage, value });
    this.props.onChange(e);
  }

  renderRequiredIfNecessary() {
    if (this.props.isRequired) {
      return (
        <abbr title="required">*</abbr>
      );
    }
  }

  composeClassNames(errorMessage, value) {
    const classNames = [
      this.props.defaultClassNames,
      this.props.className
    ];
    if (this.state.errorMessage) {
      classNames.push('has-error')
    };
    return classNames.join(" ");
  }

  maxLength() {
    if (this.props.maxLength) { return this.props.maxLength; }
  }

  renderSelectSpan() {
    if (this.props.inputType === 'select') {
      return <span className="form-control__indicator"></span>
    }
  }

  renderInput() {
    if (this.props.inputType === 'select') {
      return (
        <select onChange={this.handleChange}
                value={this.props.value}
                type={this.props.inputType}
                name={this.props.name}
                id={this.props.name} >
                  {map(this.props.options, (key, value) =>
                   <option value={value}>{key}</option>
                  )}
          </select>
      )
    } else {
      return (
        <input onChange={this.handleChange}
               value={this.state.value}
               type={this.props.inputType}
               name={this.props.name}
               id={this.props.name}
               maxLength={this.maxLength()} />
      );
    }
  }

  render() {
    return (
      <div className={this.composeClassNames(this.state.errorMessage, this.state.value)}>
        <label className="form-control">
          <div className="form-control__label" htmlFor={this.props.name}>
            <span>{this.props.label}</span> {this.renderRequiredIfNecessary()}
          </div>
          <div className="form-control__input">
            {this.renderInput()}
            {this.renderSelectSpan()}
          </div>
        </label>
        <ValidationErrorMessage errorMessage={this.state.errorMessage} />
      </div>
    )
  }
}
